import { VoucherEntity } from '@citydeals/category';

export class RemoveBookmarkAction {
  static type = '[BOOKMARK] Remove bookmark';

  constructor(readonly voucher: VoucherEntity) {}
}
